import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button, Dropdown } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import './Header.scss';
import logo from '../../../assets/images/tekstas-logo.svg';
import ScheduleButton from '../../common/ScheduleButton/ScheduleButton';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isExhibitionPage = location.pathname.includes('/exhibitions') || location.pathname.includes('/exhibition/');

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (isExhibitionPage) {
        setIsScrolled(true);
      } else {
        setIsScrolled(scrollPosition > 50);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isExhibitionPage]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language;

  return (
    <Navbar expand="lg" className={`navbar-dark ${isScrolled ? 'scrolled' : ''}`}>
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img src={logo} alt="Tekstas Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link as={Link} to="/">{t('nav.home')}</Nav.Link>
            <Nav.Link href="#about" onClick={(e) => handleNavClick(e, 'about')}>{t('nav.about')}</Nav.Link>
            <Nav.Link href="#certificates" onClick={(e) => handleNavClick(e, 'certificates')}>{t('nav.certificates')}</Nav.Link>
            <Nav.Link href="#careers" onClick={(e) => handleNavClick(e, 'careers')}>{t('nav.careers')}</Nav.Link>
            <Nav.Link as={Link} to="/exhibitions">{t('nav.exhibitions')}</Nav.Link>
          </Nav>
          <div className="d-flex align-items-center gap-3">
            {/* Language Switcher */}
            <Dropdown>
              <Dropdown.Toggle 
                variant="outline-light" 
                size="sm"
                className="language-btn"
              >
                <Globe size={14} />
                {currentLanguage === 'tr' ? 'TR' : 'EN'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item 
                  onClick={() => changeLanguage('tr')}
                  active={currentLanguage === 'tr'}
                >
                  🇹🇷 Türkçe
                </Dropdown.Item>
                <Dropdown.Item 
                  onClick={() => changeLanguage('en')}
                  active={currentLanguage === 'en'}
                >
                  🇺🇸 English
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <ScheduleButton>{t('common.schedule_call')}</ScheduleButton>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;